module.exports = __webpack_public_path__ + "static/media/hex.5a352565.svg";